module.exports = __webpack_public_path__ + "static/media/phone-mobile.b078d0a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-mobile.jpg
// module id = 593
// module chunks = 0